/**
 *
 * Module:        Library
 * Name:          Guru Chat History Model
 * Description:   Filters and groups Guru chat summaries for responsive history views
 * Developers:    Adrian Engelmann, Kiran Jayaramu, Nicu Bratescu, Daniela Popescu
 * Copyright:     Copyright 2026 by Qalgo GmbH (www.qalgo.de). All rights reserved.
 *
 */

const DAY_MS = 24 * 60 * 60 * 1000;

export const filterGuruChats = (chats, search) => {
	const query = String(search || '').trim().toLocaleLowerCase();
	return query
		? chats.filter(chat => String(chat.title || '').toLocaleLowerCase().includes(query))
		: chats;
};

export const groupRecentGuruChats = (chats, labels, now = new Date()) => {
	const startOfToday = new Date(now);
	startOfToday.setHours(0, 0, 0, 0);
	const groups = [
		{label: labels.today, chats: []},
		{label: labels.last7Days, chats: []},
		{label: labels.older, chats: []}
	];
	for (const chat of chats) {
		const timestamp = new Date(chat.updatedAt || chat.createdAt || 0).getTime();
		if (timestamp >= startOfToday.getTime()) groups[0].chats.push(chat);
		else if (timestamp >= startOfToday.getTime() - (6 * DAY_MS)) groups[1].chats.push(chat);
		else groups[2].chats.push(chat);
	}
	return groups.filter(group => group.chats.length);
};
